import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { configDataSelector, isLoadingGeneralSelector } from "../../../services/general/selectors";
import StepsMultiColumn from "../../../components/StepsMultiColumn";
import { iFrameCssClasses } from "../../../components/IFramePanel/hooks/useIframeCommand";
import IFramesTabs from "../../../components/IFramesTabs";

import useMenu from "./hooks/useMenu";
import useIframeColorsList from "./hooks/useIframeColorsList";
import Templates from "./Templates";
import useTemplateData from "./hooks/useTemplateData";
import useMenuActions from "./hooks/useMenuActions";

const StepTwoConfigurator = () => {
    const [ disableIframeActions , setDisableIframeActions ] = useState(true);
    const [ currentIframeRef, setCurrentIframeRef ] = useState(null);
    const [ currentIframeWrapperRef, setCurrentIframeWrapperRef ] = useState(null);
    const [ clickedElement, setClickedElement ] = useState(null);

    const isLoading = useSelector(isLoadingGeneralSelector);
    const config = useSelector(configDataSelector);
    const templates = config?.templates;

    const templatesData = useTemplateData({ templates });
    const { currentTemplate, onUpdateTemplateSelector } = templatesData;

    const {
        getPathTo,
        highlightElement,
        clearCssClassName,
        handleViewSelector,
        getElementsByText
    } = useIframeColorsList(currentIframeRef);

    const { onElementWithText, onTextAnyElement } = useMenuActions({
        clickedElement,
        onUpdateTemplateSelector,
        currentTemplate,
        getPathTo
    });

    const { onMenuOpen, ...restMenuProps } = useMenu({
        clickedElement,
        setClickedElement,
        currentIframeRef,
        onElementWithText,
        onTextAnyElement
    });

    const handleElementClick = useCallback(
        (element) => {
            if(disableIframeActions) {
                return;
            }

            setClickedElement(element);
        },
        [ disableIframeActions ]
    );

    useEffect(() => {
        if(!clickedElement) {
            return;
        }

        const xpath = getPathTo(clickedElement.target);
        clearCssClassName(iFrameCssClasses.active);
        highlightElement(xpath, iFrameCssClasses.active);

        onMenuOpen();
    },
    [ clearCssClassName, clickedElement, getPathTo, highlightElement, onMenuOpen ]
    );

    useEffect(
        () => {
            if(!currentTemplate) {
                setDisableIframeActions(true);
            } else {
                setDisableIframeActions(false);
            }
        },
        [ currentTemplate ]
    );

    return (
        <StepsMultiColumn
            isLoading={isLoading}
            controls={(
                <Templates
                    currentIframeRef={currentIframeRef}
                    currentIframeWrapperRef={currentIframeWrapperRef}
                    templatesData={templatesData}
                    handleViewSelector={handleViewSelector}
                    getPathTo={getPathTo}
                    getElementsByText={getElementsByText}
                    highlightElement={highlightElement}
                    clearCssClassName={clearCssClassName}
                />
            )}
            iframes={(
                <IFramesTabs
                    setCurrentIframeRef={setCurrentIframeRef}
                    setCurrentIframeWrapperRef={setCurrentIframeWrapperRef}
                    onElementClick={handleElementClick}
                    menuProps={restMenuProps}
                />
            )}
        />
    );
};

export default StepTwoConfigurator;
